import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { get, post } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth'

@Injectable({
  providedIn: 'root'
})
export class UsersApiService {

  constructor() { }

  async getHeaders() {
    const session = await fetchAuthSession();
    const token = session.tokens ?.idToken;
    let authToken = token ?.toString();
    if (authToken) {
      return {
        Authorization: authToken
      }
    }
    return;
  }

  async getUsers() {
    let queryParams: any = {
      resource: 'getUsers'
    };
    const session = await fetchAuthSession();
    const token = session.tokens ?.idToken;
    let authToken = token ?.toString();
    if (authToken) {
      try {
        const restOperation = get({
          apiName: 'CompletePestControlApi',
          path: 'usersApi',
          options: {
            headers: {
              Authorization: authToken
            },
            queryParams: queryParams
          }
        });
        const { body } = await restOperation.response;
        const json = await body.json();
        console.log('UsersApiService getUsers json', json);
      } catch (error) {
        console.log('GET call failed with error: ', error);
      }
    }
  }

  async getUsersInGroup(groupName: string) {
    let queryParams: any = {
      resource: 'getUsersForGroup',
      groupName: groupName
    };
    const session = await fetchAuthSession();
    const token = session.tokens ?.idToken;
    let authToken = token ?.toString();
    if (authToken) {
      try {
        const restOperation = get({
          apiName: 'CompletePestControlApi',
          path: 'usersApi',
          options: {
            headers: {
              Authorization: authToken
            },
            queryParams: queryParams
          }
        });
        const { body } = await restOperation.response;
        const json = await body.json();
        console.log('UsersApiService getUsersInGroup json', json);
      } catch (error) {
        console.log('GET call failed with error: ', error);
      }
    }
  }

}
